class ScrollingText {
	constructor( text ) {

		const showDemo = () => {
			document.scrollingElement.scrollTo(0, 0);

			const w = text;
			const x = 400;
			const xEnd = -400;
			// const [x, xEnd] = (index % 2) ? ['100%', (w.scrollWidth - section.offsetWidth) * 1] : [w.scrollWidth * 1, 0];
			// const [x, xEnd] = (index % 2) ? ['100%', '-400px'] : ['-400px', 0];
			gsap.fromTo(w, {  x  }, {
			x: xEnd,
			scrollTrigger: {
				trigger: ".block-featured-strip__video-wrap",
				scrub: 0.5
			}
			});
		}

		showDemo();

	}
}

export default ScrollingText;
